import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpGet, httpPut, httpDelete } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { vmPath, homePath, vmEditPath } from 'routes'

import r from 'reactotron-react-js'

const FETCH_SUPPLIER = makeKeys('FETCH_SUPPLIER')

export const fetchSuppliers = makeAction(FETCH_SUPPLIER.REQUEST, 'query')

const fetchSuppliersSuccess = makeAction(FETCH_SUPPLIER.SUCCESS, 'data')

const supplierApiPath = path => path ? urlWithPrefix(`vendorMaintenances/${path}`) : urlWithPrefix('vendorMaintenances')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* fetchSuppliersRequest(action) {
  const { query } = action.payload
  try {
    yield put(appLoading('Loading Supplier Data.'))
    const response = yield httpGet(supplierApiPath('suppliers'), query)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchSuppliersSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(fetchSuppliers(query))
    } else {
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load supplier data error!'))
      }
    }
  }
}

export function* watchSupplierSaga() {
  yield takeLatest(FETCH_SUPPLIER.REQUEST, fetchSuppliersRequest)
}

const initial = {
  listSupplier: { data: {}, loading: false },
}

export default createReducer(initial, state => ({
  [FETCH_SUPPLIER.REQUEST]: () => ({
    ...state,
    listSupplier: { data: [], loading: true }
  }),
  [FETCH_SUPPLIER.SUCCESS]: (data) => ({
    ...state,
    listSupplier: { data: data.data, loading: false }
  }),
}))